import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  GetApplicationsMarathonPublicParams,
  GetApplicationsMarathonPublicResponse,
} from "api/api/applicationsApi/types";

export const getApplicationsMarathonPublic = createAsyncThunk<
  GetApplicationsMarathonPublicResponse,
  GetApplicationsMarathonPublicParams
>(
  "applications/getApplicationsMarathonPublic",
  async ({ marathonId, ...params }, { rejectWithValue }) => {
    try {
      const data = await ApplicationsAPI.getApplicationsMarathonPublic({
        marathonId,
        ...params,
      });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting applications marathon public",
          error.response?.data
        );
        return rejectWithValue(error.response?.data || "Unknown error");
      } else {
        console.error(
          "Error while getting applications marathons public",
          error
        );
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
